import Text from '@passkeys/ui/text';

import type {
  ActivityEntry,
  LabelEntry,
} from '@/ui/flux/tx-log/selectors/create-filtered-activity';
import TxRow from './tx-row.js';

function LabelRow({ label }: LabelEntry) {
  return (
    <div className="mb-3 mt-6 w-fit rounded-full bg-black/3 px-2 py-0.5 theme-dark:bg-white/3">
      <Text className="theme-dark:text-white/40" monospace size={12}>
        {label}
      </Text>
    </div>
  );
}

interface ActivityProps {
  activity: ActivityEntry[];
}

function Activity({ activity }: ActivityProps) {
  return (
    <div className="box-content flex w-full flex-col overflow-y-auto px-4 pb-4 scrollbar-hide">
      {activity.map((entry) =>
        entry.type === 'label' ? (
          <LabelRow key={entry.id} {...entry} />
        ) : (
          <TxRow key={entry.id} activityItem={entry} />
        ),
      )}
    </div>
  );
}

export default Activity;
